/* ADD GROUPS */
export const LIST_ABILITIES_BY_USER_AND_GROUP =
  "LIST_ABILITIES_BY_USER_AND_GROUP"
export const LIST_ABILITIES_BY_USER_AND_GROUP_SUCCESS =
  "LIST_ABILITIES_BY_USER_AND_GROUP_SUCCESS"
export const LIST_ABILITIES_BY_USER_AND_GROUP_CLEAN =
  "LIST_ABILITIES_BY_USER_AND_GROUP_CLEAN"
export const LIST_ABILITIES_BY_USER_AND_GROUP_ERROR =
  "LIST_ABILITIES_BY_USER_AND_GROUP_ERROR"
